<template>

    <div class="summary-content-panel-wrapper">

        <v-expansion-panel v-if="datasummary" id="expansions-list" expand>

            <v-expansion-panel-content v-if="mustShowPanel('overview') && datasummary.overview"
                                       :id="'overview' + panelKeySuffix"
                                       :ref="'panel-content-overview' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.overview.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>
                    <v-card-text>
                        <v-flex class="no-padding-left no-padding-right" xs12>
                            <v-layout class="margin-bottom-info" row wrap>

                                <v-flex xs12 sm6 md4>
                                    <div>
                                        <h4>{{datasummary.texts["api.summary.communication.assessment.column"]}}</h4>
                                    </div>

                                    <div v-if="datasummary.overview.msitatList && datasummary.overview.msitatList.length > 0">
                                        <h4>{{datasummary.texts["api.summary.communication.assessment.msitat"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span
                                                v-for="(msitat, msitatIndex) in datasummary.overview.msitatList"
                                                :key="'msitat-' + msitatIndex">
                                                    <span v-if="msitatIndex > 0">, </span>
                                                    <span>{{msitat}}</span>
                                            </span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.symptomList">
                                        <h4>{{datasummary.texts["api.summary.communication.assessment.symptoms"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span v-for="(symptom, symptomIndex) in datasummary.overview.symptomList" :key="'symptom-'+symptomIndex">
                                                <span v-if="symptomIndex > 0">, </span>
                                                <span v-if="symptomIndex === 0"><b>{{symptom}}</b></span>
                                                <span v-else>{{symptom}}</span>
                                            </span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.assessmentToken">
                                        <h4>{{datasummary.texts["api.summary.communication.assessment.number"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.assessmentToken}}</span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.assessmentVersion && datasummary.overview.versionList && datasummary.overview.assessmentToken">
                                        <h4>{{datasummary.texts["api.summary.communication.assessment.version"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>
                                                <span
                                                    v-for="(version, versionIndex) in datasummary.overview.versionList"
                                                    :key="'version-'+versionIndex">
                                                    <span v-if="(versionIndex > 0)">, </span>
                                                    <span v-if="version === datasummary.overview.assessmentVersion"><b>{{version}}</b></span>
                                                    <span v-else>
                                                        <span @click="goToSummaryVersionPage(datasummary.overview.assessmentToken, version)" class="version-nav-link cursor-pointer">{{version}}</span>
                                                    </span>
                                                </span>
                                            </span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.assessmentDate">
                                        <h4>{{datasummary.texts["api.summary.communication.evaluation.time"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.assessmentDate}}</span>
                                        </p>
                                    </div>


                                </v-flex>


                                <v-flex xs12 sm6 md4>
                                    <div>
                                        <h4>{{datasummary.texts["api.summary.communication.user.column"]}}</h4>
                                    </div>


                                    <div v-if="datasummary.overview.userInformation">
                                        <h4>{{datasummary.texts["api.summary.communication.user.name.first"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.userInformation.firstName}}</span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.userInformation">
                                        <h4>{{datasummary.texts["api.summary.communication.user.name.last"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.userInformation.name}}</span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.userInformation.institution">
                                        <h4>{{datasummary.texts["api.summary.communication.user.institution"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.userInformation.institution}}</span>
                                        </p>
                                    </div>
                                </v-flex>


                                <v-flex xs12 sm6 md4 v-if="datasummary.overview.patientInformation && (
                                                                  datasummary.overview.patientInformation.firstName ||
                                                                  datasummary.overview.patientInformation.name ||
                                                                  datasummary.overview.patientInformation.comment ||
                                                                  datasummary.overview.patientInformation.pid ||
                                                                  datasummary.overview.patientInformation.name ||
                                                                  datasummary.overview.patientInformation.birthdate)">
                                    <div>
                                        <h4>{{datasummary.texts["api.summary.communication.patient.column"]}}</h4>
                                    </div>

                                    <div v-if="datasummary.overview.patientInformation.pid">
                                        <h4>{{datasummary.texts["api.summary.communication.patient.pid"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.patientInformation.pid }}</span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.patientInformation.comment">
                                        <h4>{{datasummary.texts["api.summary.communication.patient.comment"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.patientInformation.comment }}</span>
                                        </p>
                                    </div>

                                    <div v-if="datasummary.overview.patientInformation.birthdate">
                                        <h4>{{datasummary.texts["api.summary.communication.patient.birthday"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.patientInformation.birthdate }}</span>
                                        </p>
                                    </div>
                                    <div v-if="datasummary.overview.patientInformation.firstName && datasummary.overview.patientInformation.name">
                                        <h4>{{datasummary.texts["api.summary.communication.patient.name"]}}</h4>
                                        <p class="font-weight-regular no-margin-bottom">
                                            <span>{{datasummary.overview.patientInformation.firstName }}. {{datasummary.overview.patientInformation.name}}.</span>
                                        </p>
                                    </div>


                                </v-flex>

                            </v-layout>
                        </v-flex>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('decision') && datasummary.decision"
                                       :id="'decision' + panelKeySuffix"
                                       :ref="'panel-content-decision' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.decision.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>
                    <v-card-text>
                        <div>
                            <v-flex xs12>
                                <v-layout >
                                    <v-flex xs12>
                                        <div v-if="datasummary.decision.decisionItem1">
                                            <h4>{{datasummary.texts["api.summary.communication.final.di1"]}}</h4>
                                            <p  v-html="datasummary.decision.decisionItem1.name"></p>
                                        </div>


                                        <div v-if="datasummary.decision.decisionItem2 && datasummary.decision.decisionItem2.name != null">
                                            <h4>{{datasummary.texts["api.summary.communication.final.di2"]}}</h4>
                                            <p class="font-weight-regular no-margin-bottom">
                                                <span v-html="datasummary.decision.decisionItem2.name"></span>
                                            </p>
                                        </div>

                                        <div v-if="datasummary.decision.decisionComment">
                                            <h4>{{datasummary.texts["api.summary.communication.final.user.comment"]}}</h4>
                                            <p class="font-weight-regular no-margin-bottom">
                                                <span v-html="datasummary.decision.decisionComment"></span>
                                            </p>
                                        </div>

                                        <div v-if="datasummary.decision.codeSystemSelectedList.length > 0">
                                            <h4 class="margin-bottom-xxs">{{datasummary.texts["api.summary.communication.codeSystem"]}}</h4>
                                            <div v-for="code in datasummary.decision.codeSystemSelectedList"
                                                 class="margin-bottom-xxs">
                                                <h5 v-if="code.codeTypeName !== 'undefined' &&
                                                          code.codeTypeName !== null &&
                                                          code.codeTypeName.length > 0">
                                                    {{code.codeTypeName}}
                                                </h5>
                                                <p class="no-margin-bottom">{{code.code}} - {{code.name}}</p>
                                            </div>
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('scoring') && datasummary.scoring"
                                       :id="'scoring' + panelKeySuffix"
                                       :ref="'panel-content-scoring' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.scoring.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card v-if="datasummary.scoring.scoringData.hasScoringData">
                    <v-card-text>
                        <div>
                            <v-flex xs12>
                                <!-- Warnings defined at "Properties and labels" per product -->
                                <v-layout v-if="datasummary.scoring.scoringData.warnings" wrap>
                                    <v-flex v-if="datasummary.scoring.scoringData.warnings.title" xs12 sm4 md3 lg4 xl3>
                                        {{datasummary.scoring.scoringData.warnings.title}}
                                    </v-flex>
                                    <v-flex class="warning-section" xs12 sm8 md9 lg8 xl9>
                                        <div class="warning-wrapper">
                                            <WarningIcon></WarningIcon>
                                            <span >{{datasummary.scoring.scoringData.warnings.description}}</span>
                                        </div>
                                        <ul v-for="warning in datasummary.scoring.scoringData.warnings.warningList"
                                            class="warning-list">
                                            <li>{{warning}}</li>
                                        </ul>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex v-if=" datasummary.scoring.scoringHeadline || datasummary.scoring.adviceHeadline || datasummary.scoring.rationalHeadline"
                                            xs12 sm4 md3 lg4 xl3>
                                        <h4>{{datasummary.scoring.scoringHeadline}}</h4>
                                    </v-flex>
                                    <v-flex xs12 sm8 md9 lg8 xl9>


                                        <h4 class="headline-decision-h3 margin-bottom-xxs">{{datasummary.texts["api.assessment.headline.di1"]}}</h4>
                                        <table role="presentation">
                                            <tr>
                                                <td v-if="datasummary.scoring.scoringData.decisions.decisionItem1.icon">
                                                    <div
                                                         v-html="datasummary.scoring.scoringData.decisions.decisionItem1.icon.replace(/COLOR_PLACEHOLDER/gi, getDecisionItemColor(datasummary.scoring.scoringData.decisions.decisionItem1))"
                                                         class="decision-item-item-svg">
                                                    </div>
                                                </td>
                                                <td>
                                                    <h4 class="decision-headline"
                                                        v-html="datasummary.scoring.scoringData.decisions.decisionItem1.headline"
                                                        v-bind:style="{'color': getDecisionItemColor(datasummary.scoring.scoringData.decisions.decisionItem1) }">
                                                    </h4>
                                                    <p  v-html="datasummary.scoring.scoringData.decisions.decisionItem1.text"></p>

                                                </td>
                                            </tr>
                                        </table>

                                        <br />

                                        <h4 v-if="datasummary.scoring.scoringData.decisions.decisionItems2 != null && datasummary.scoring.scoringData.decisions.decisionItems2.length > 0" class="headline-decision-h3 margin-bottom-xxs">{{datasummary.texts["api.assessment.headline.di2"]}}</h4>

                                        <div v-for="decisionItem2 in datasummary.scoring.scoringData.decisions.decisionItems2">
                                            <table v-if="!decisionItem2.target" role="presentation">
                                                <tr>

                                                    <td>
                                                        <h4  class="decision-headline"
                                                             v-html="decisionItem2.headline"
                                                             v-bind:style="{'color': getDecisionItemColor(decisionItem2) }">
                                                        </h4>
                                                        <p
                                                            class="decision-text"
                                                            v-html="decisionItem2.text">
                                                        </p>
                                                    </td>
                                                </tr>
                                            </table>

                                            <table v-else role="presentation">
                                                <tr>
                                                    <td>
                                                        <WarningIcon
                                                             class="ambulance-scoring scoring-page" style="position: relative; top: 0;">
                                                        </WarningIcon>
                                                    </td>
                                                    <td>
                                                        <h4  class="decision-headline"
                                                             v-html="decisionItem2.headline"
                                                             v-bind:style="{'color': getDecisionItemColor(decisionItem2) }">
                                                        </h4>
                                                        <p class="decision-text"
                                                           v-html="decisionItem2.text">
                                                        </p>
                                                    </td>
                                                </tr>

                                            </table>


                                        </div>

                                        <br />

                                        <div v-if="datasummary.scoring.scoringData.decisions.decisionItems3.length > 0">
                                            <h4 class="headline-decision-h3 margin-bottom-xxs">{{datasummary.texts["api.assessment.headline.di3"]}}</h4>

                                            <div v-if="datasummary.scoring.scoringData.decisions.decisionItems3Recommended && datasummary.scoring.scoringData.decisions.decisionItems3Recommended.length > 0" class="decision-item-header">
                                                {{ text('api.assessment.headline.di3.recommended') }}
                                            </div>
                                            <div class="padding-left-s" v-for="decisionItem3 in datasummary.scoring.scoringData.decisions.decisionItems3Recommended">
                                                <table role="presentation">
                                                    <tr>
                                                        <td v-if="decisionItem3.icon">
                                                            <div
                                                                 v-html="decisionItem3.icon"
                                                                 class="decision-item-item-svg">
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <h4 class="decision-headline di-headline"
                                                                v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                v-html="decisionItem3.headline">
                                                            </h4>
                                                            <p v-if="decisionItem3.text"
                                                               class="decision-text"
                                                               v-html="decisionItem3.text">
                                                            </p>
                                                        </td>

                                                    </tr>
                                                </table>
                                            </div>

                                            <div v-if="datasummary.scoring.scoringData.decisions.decisionItems3Possible && datasummary.scoring.scoringData.decisions.decisionItems3Possible.length > 0" class="decision-item-header">
                                                {{ text('api.assessment.headline.di3.possible') }}
                                            </div>
                                            <div class="padding-left-s" v-for="decisionItem3 in datasummary.scoring.scoringData.decisions.decisionItems3Possible">
                                                <table role="presentation">
                                                    <tr>
                                                        <td v-if="decisionItem3.icon">
                                                            <div
                                                                v-html="decisionItem3.icon"
                                                                class="decision-item-item-svg">
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <h4 class="decision-headline di-headline"
                                                                v-bind:style="{'color': getDecisionItemColor(decisionItem3) }"
                                                                v-html="decisionItem3.headline">
                                                            </h4>
                                                            <p v-if="decisionItem3.text"
                                                               class="decision-text"
                                                               v-html="decisionItem3.text">
                                                            </p>
                                                        </td>

                                                    </tr>
                                                </table>
                                            </div>
                                            <br/>
                                        </div>

                                        <div v-if="datasummary.scoring.scoringData.decisions.decisionItems4.length > 0">
                                            <h4 class="headline-decision-h3 margin-bottom-xxs">{{datasummary.texts["api.assessment.headline.di4"]}}</h4>

                                            <div v-if="datasummary.scoring.scoringData.decisions.decisionItems4Recommended && datasummary.scoring.scoringData.decisions.decisionItems4Recommended.length > 0" class="decision-item-header">
                                                {{ text('api.assessment.headline.di4.recommended') }}
                                            </div>
                                            <div class="padding-left-s" v-for="decisionItem4 in datasummary.scoring.scoringData.decisions.decisionItems4Recommended">
                                                <table role="presentation">
                                                    <tr>
                                                        <td v-if="decisionItem4.icon" >
                                                            <div
                                                                 v-html="decisionItem4.icon"
                                                                 class="decision-item-item-svg">
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem4) }"
                                                                v-html="decisionItem4.headline"
                                                                class="decision-headline di-headline">
                                                            </h4>
                                                            <p v-if="decisionItem4.text"
                                                               class="decision-text"
                                                               v-html="decisionItem4.text">
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>

                                            <div v-if="datasummary.scoring.scoringData.decisions.decisionItems4Possible && datasummary.scoring.scoringData.decisions.decisionItems4Possible.length > 0" class="decision-item-header">
                                                {{ text('api.assessment.headline.di4.possible') }}
                                            </div>
                                            <div class="padding-left-s" v-for="decisionItem4 in datasummary.scoring.scoringData.decisions.decisionItems4Possible">
                                                <table role="presentation">
                                                    <tr>
                                                        <td v-if="decisionItem4.icon" >
                                                            <div
                                                                v-html="decisionItem4.icon"
                                                                class="decision-item-item-svg">
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <h4 v-bind:style="{'color': getDecisionItemColor(decisionItem4) }"
                                                                v-html="decisionItem4.headline"
                                                                class="decision-headline di-headline">
                                                            </h4>
                                                            <p v-if="decisionItem4.text"
                                                               class="decision-text"
                                                               v-html="decisionItem4.text">
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <br/>
                                        </div>

                                        <div v-if="datasummary.scoring.scoringData.notes.length > 0">
                                            <h4 class="headline-decision-h3">{{datasummary.texts["api.assessment.headline.notes"]}}</h4>
                                            <div v-for="note in datasummary.scoring.scoringData.notes">
                                                <table class="note-table" role="presentation">
                                                    <tr>
                                                        <td>
                                                            <h4 v-if="note.text"
                                                                v-html="note.text"
                                                                class="decision-headline di-headline">
                                                            </h4>
                                                            <p class="decision-text note-text"
                                                               v-if="note.description"
                                                               v-html="note.description">
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <br/>
                                        </div>


                                    </v-flex>
                                </v-layout>

                                <v-layout v-if="datasummary.scoring.scoringData.comments.commentTexts.length" class="summary-table-td" wrap>
                                    <v-flex v-if="datasummary.scoring.scoringHeadline || datasummary.scoring.adviceHeadline || datasummary.scoring.rationalHeadline" xs12 sm4 md3 lg4 xl3>
                                         <h4>{{datasummary.scoring.rationalHeadline}}</h4>
                                    </v-flex>
                                    <v-flex xs12 sm8 md9 lg8 xl9>
                                        <div v-for="comment in datasummary.scoring.scoringData.comments.commentTexts" v-if="comment.length > 0">
                                            <p v-html="comment"></p>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="datasummary.scoring.scoringData.recommendations.recommendationsSections.length" class="summary-table-td" wrap>
                                    <v-flex v-if="datasummary.scoring.scoringHeadline || datasummary.scoring.adviceHeadline || datasummary.scoring.rationalHeadline" xs12 sm4 md3 lg4 xl3>
                                        <h4>{{datasummary.scoring.adviceHeadline}}</h4>
                                    </v-flex>
                                    <v-flex xs12 sm8 md9 lg8 xl9>
                                        <div v-for="recommendation in datasummary.scoring.scoringData.recommendations.recommendationsSections">
                                            <h4 v-html="recommendation.title"></h4>
                                            <div v-for="recommendationtext in recommendation.recommendationsTexts">
                                                <ul v-if="recommendationtext.type === 'LIST_ITEM' && recommendationtext.text">
                                                    <li class="recommendationlist" v-html="recommendationtext.text"></li>
                                                </ul>
                                                <p v-else v-html="recommendationtext.text"></p>
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>

                                <!-- Warning to appear all the time above Code Systems and controlled by CODING_SYSTEM_WARNING_DISPLAY AppProperty (default true) -->
                                <v-layout v-if="Object.keys(datasummary.scoring.scoringData.codeSystemList).length > 0 && datasummary.assessmentAppPropertiesMap && datasummary.assessmentAppPropertiesMap.CODING_SYSTEM_WARNING_DISPLAY === 'true'" wrap>
                                    <v-flex xs12 sm4 md3 lg4 xl3>

                                    </v-flex>
                                    <v-flex xs12 sm8 md9 lg8 xl9>
                                        <div v-if="datasummary.assessmentAppPropertiesMap && datasummary.assessmentAppPropertiesMap.CODING_SYSTEM_WARNING_DISPLAY === 'true'" class="diagnosis-warning">
                                            <div class="diagnosis-warning-title">
                                                <WarningIcon></WarningIcon>
                                                <span>{{datasummary.texts["api.summary.communication.codeSystem.warning.label"]}}</span>
                                            </div>
                                            <div class="diagnosis-warning-description">
                                                <p>
                                                    {{datasummary.texts["api.summary.communication.codeSystem.warning.description"]}}
                                                </p>
                                            </div>
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-if="Object.keys(datasummary.scoring.scoringData.codeSystemList).length > 0"
                                          v-for="(codeSystem, key) in datasummary.scoring.scoringData.codeSystemList"
                                          :key="'code-system-'+key"
                                          class="code-system-value summary-table-td"
                                          wrap
                                >
                                    <v-flex xs12 sm4 md3 lg4 xl3>
                                        <h4 v-if="codeSystem.name !== 'undefined' &&
                                                  codeSystem.name !== null &&
                                                  codeSystem.name.length > 0">
                                            {{codeSystem.name}}
                                        </h4>
                                    </v-flex>
                                    <v-flex xs12 sm8 md9 lg8 xl9>
                                        <div
                                             class="margin-bottom-xxs">
                                            <div v-for="code in codeSystem.articles" class="code-system code-system-block">
                                                <ul >
                                                    <!--display code.name if code.commonName === null -->
                                                    <li class="common-name-code-system">
                                                        {{code.code}} - {{code.name}}
                                                    </li>
                                                    <div class='likelihood' v-if="code.likelihood !== null">
                                                        <div class='progress bg-color-primary' v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                    </div>
                                                    <!--don't display code.name if code.commonName === null-->
                                                    <p class="code-system-article-name">
                                                        {{code.commonName}}
                                                    </p>
                                                    <p class="code-system-description" v-html="code.commonDescription"></p>
                                                </ul>
                                            </div>
                                        </div>
                                    </v-flex>

                                </v-layout>


                            </v-flex>

                        </div>
                    </v-card-text>
                </v-card>

                <v-card v-else>
                    <v-card-text>
                        <div>
                            <v-flex xs12>
                                    <v-layout>
                                        <v-flex>
                                            <p>{{datasummary.texts["api.evaluation.noDecision"]}}</p>

                                            <div class="warning-section" v-if="datasummary.scoring.scoringData.warnings">
                                                <div class="warning-wrapper">
                                                    <WarningIcon>
                                                    </WarningIcon>
                                                    <span v-if="datasummary.scoring.scoringData.warnings.title"
                                                        class="headline-decision-h3">
                                                        {{ datasummary.scoring.scoringData.warnings.title }}
                                                    </span>
                                                </div>


                                                <span v-if="datasummary.scoring.scoringData.warnings.description"
                                                    class="di-headline">
                                                    {{datasummary.scoring.scoringData.warnings.description}}
                                                </span>

                                                <div v-for="warning in datasummary.scoring.scoringData.warnings.warningList">
                                                    <ul class="warning-list margin-bottom-xxs">
                                                        <li>{{ warning }}</li>
                                                    </ul>
                                                </div>
                                            </div>

                                            <div v-if="datasummary.scoring.scoringData.comments.commentTexts.length > 0">
                                                <h4 v-if="datasummary.scoring.scoringHeadline || datasummary.scoring.adviceHeadline || datasummary.scoring.rationalHeadline"
                                                    class="headline-decision-h3">
                                                    {{datasummary.scoring.rationalHeadline}}
                                                </h4>
                                                <div>
                                                    <div v-for="comment in datasummary.scoring.scoringData.comments.commentTexts" v-if="comment.length > 0">
                                                        <p v-html="comment"></p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="datasummary.scoring.scoringData.notes.length > 0">
                                                <h4 class="headline-decision-h3">{{datasummary.texts["api.assessment.headline.notes"]}}</h4>
                                                <div v-for="note in datasummary.scoring.scoringData.notes">
                                                    <table class="note-table" role="presentation">
                                                        <tr>
                                                            <td>
                                                                <h4 v-if="note.text"
                                                                    v-html="note.text"
                                                                    class="decision-headline di-headline">
                                                                </h4>
                                                                <p class="decision-text note-text"
                                                                   v-if="note.description"
                                                                   v-html="note.description">
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>

                                            <div v-if="datasummary.assessmentAppPropertiesMap && datasummary.assessmentAppPropertiesMap.CODING_SYSTEM_WARNING_DISPLAY === 'true'" class="diagnosis-warning">
                                                <div class="diagnosis-warning-title">
                                                    <WarningIcon></WarningIcon>
                                                    <span>{{datasummary.texts["api.summary.communication.codeSystem.warning.label"]}}</span>
                                                </div>
                                                <div class="diagnosis-warning-description">
                                                    <p>
                                                        {{datasummary.texts["api.summary.communication.codeSystem.warning.description"]}}
                                                    </p>
                                                </div>
                                            </div>

                                            <div v-if="Object.keys(datasummary.scoring.scoringData.codeSystemList).length > 0"
                                                 v-for="(codeSystem, key) in datasummary.scoring.scoringData.codeSystemList"
                                                 :key="'code-system-'+key"
                                                 class="code-system-value">
                                                <table class="summary-table-td summary-table-td-code-system" role="presentation">
                                                    <tr>
                                                        <td class="padding-right-m code-system-table-name">
                                                            <h4 >
                                                                {{codeSystem.name}}
                                                            </h4>
                                                        </td>
                                                        <td >
                                                            <div
                                                                 class="margin-bottom-xxs">
                                                                <div v-for="code in codeSystem.articles" class="code-system code-system-block">
                                                                    <ul >
                                                                        <!--display code.name if code.commonName === null -->
                                                                        <li class="common-name-code-system">
                                                                            {{code.code}} - {{code.name}}
                                                                        </li>
                                                                        <div class='likelihood' v-if="code.likelihood !== null">
                                                                            <div class='progress bg-color-primary' v-bind:style="{'width': code.likelihood + '%'}"></div>
                                                                        </div>
                                                                        <!--don't display code.name if code.commonName === null-->
                                                                        <p class="code-system-article-name">
                                                                            {{code.commonName}}
                                                                        </p>
                                                                        <p class="code-system-description" v-html="code.commonDescription"></p>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>

                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('startQuestions') && datasummary.startQuestions"
                                       :id="'startQuestions' + panelKeySuffix"
                                       :ref="'panel-content-startQuestions' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container list-items">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.startQuestions.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>
                    <v-card-text>
                        <div>
                            <v-flex xs12>
                                <v-layout v-for="(starq, i) in datasummary.startQuestions.questions " :key="'startQuestion-'+i" class="list summary-question-row">
                                    <v-flex xs4 sm3 md3 lg3>
                                        <p>{{starq.questionName}}</p>
                                    </v-flex>
                                    <v-flex xs4 sm6 md6 lg6>
                                        <p>{{starq.questionText}}</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3 lg3>
                                         <p>{{starq.answerText}}
                                             <AnswerInfoPopup
                                             v-if="(getAppPropertyValueArray('SHOW_AVAILABLE_ANSWERS', {mustUppercaseAll: true}).indexOf('SUMMARY') > -1)"
                                             :questionList="starq.availableAnswers" />
                                         </p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('generalQuestions') && datasummary.generalQuestions"
                                       :id="'generalQuestions' + panelKeySuffix"
                                       :ref="'panel-content-generalQuestions' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container list-items">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.generalQuestions.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>

                    <v-card-text v-if="datasummary.generalQuestions.questions.length">
                        <div>
                            <v-flex xs12>
                                <v-layout  v-for="(genq, i) in datasummary.generalQuestions.questions" :key="'generalQuestion-'+i" class="list summary-question-row">
                                    <v-flex xs4 sm3 md3 lg3>
                                        <p>{{genq.questionName}}</p>
                                    </v-flex>
                                    <v-flex xs4 sm6 md6 lg6>
                                        <p>{{genq.questionText}}</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3 lg3>
                                        <p>{{genq.answerText}}
                                         <AnswerInfoPopup
                                         v-if="(getAppPropertyValueArray('SHOW_AVAILABLE_ANSWERS', {mustUppercaseAll: true}).indexOf('SUMMARY') > -1)"
                                         :questionList="genq.availableAnswers" />
                                     </p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>

                    <v-card-text v-if="!datasummary.generalQuestions.questions.length">

                        <p>{{datasummary.texts["api.summary.communication.answer.nothing"]}}</p>

                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('symptoms') && datasummary.symptoms"
                                       :id="'symptoms' + panelKeySuffix"
                                       :ref="'panel-content-symptoms' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container list-items">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.symptoms.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>
                    <v-card-text v-if="datasummary.symptoms.noOtherSymptomWarning" class="padding-bottom-s">
                        <h4>{{datasummary.symptoms.noOtherSymptomWarning.title}}</h4>
                        <p>{{datasummary.symptoms.noOtherSymptomWarning.description}}</p>
                        <ul v-for="symptomWarning in datasummary.symptoms.noOtherSymptomWarning.warningList" class="warning-list margin-bottom-xxs">
                            <li>{{symptomWarning}}</li>
                        </ul>
                    </v-card-text>
                    <v-card-text v-if="datasummary.symptoms.symptomsData.length">
                        <div v-for="(symptom, i) in datasummary.symptoms.symptomsData" :key="'symptom-'+i" v-if="symptom.symptomName !== '' || symptom.questions.length > 0" class="padding-bottom-xs padding-top-xs">
                            <h4 class="symptom-name">{{symptom.symptomName}}</h4>
                            <v-flex xs12>
                                <v-layout class="list component-bg-color summary-question-row" v-if="symptom.mainQuestion.questionName !== null">
                                    <v-flex xs4 sm3 md3 lg3 class="break-word">
                                        <p >{{symptom.mainQuestion.questionName}}</p>
                                    </v-flex>
                                    <v-flex xs5 sm6 md6 lg6>
                                        <p>{{symptom.mainQuestion.questionText}}</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3 lg3>
                                        <p>{{symptom.mainQuestion.answerText}}
                                            <AnswerInfoPopup
                                            v-if="(getAppPropertyValueArray('SHOW_AVAILABLE_ANSWERS', {mustUppercaseAll: true}).indexOf('SUMMARY') > -1)"
                                            :questionList="symptom.mainQuestion.availableAnswers" />
                                        </p>
                                    </v-flex>
                                </v-layout>

                                <v-layout v-for="(question, i) in symptom.questions" :key="'question-'+i" class="list component-bg-color summary-question-row">
                                    <v-flex xs4 sm3 md3 lg3 class="break-word">
                                        <p>{{question.questionName}}</p>
                                    </v-flex>
                                    <v-flex xs5 sm6 md6 lg6>
                                        <p>{{question.questionText}}</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3 lg3>
                                        <p>{{question.answerText}}
                                            <AnswerInfoPopup
                                            v-if="(getAppPropertyValueArray('SHOW_AVAILABLE_ANSWERS', {mustUppercaseAll: true}).indexOf('SUMMARY') > -1)"
                                            :questionList="question.availableAnswers" />
                                        </p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="!datasummary.symptoms.symptomsData.length">

                        <p>{{datasummary.texts["api.summary.communication.answer.nothing"]}}</p>

                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


            <v-expansion-panel-content v-if="mustShowPanel('sharedQuestions') && datasummary.sharedQuestions"
                                       :id="'sharedQuestions' + panelKeySuffix"
                                       :ref="'panel-content-sharedQuestions' + panelKeySuffix"
                                       :value="isExpanded"
                                       class="expansion-list decisions-container list-items">
                <div slot="header" class="color-headings-text font-size-medium">
                    {{datasummary.sharedQuestions.title}}
                </div>
                <div
                    slot="actions"
                    class="svg-wrapper"
                    :style="{
                        'width': 30 + 'px',
                        'height': 30 + 'px'
                    }"
                >
                    <ExpandIcon v-if="!isExpanded" :width="30" :height="30"/>
                    <CollapseIcon v-else :width="30" :height="30"/>
                </div>
                <v-card>
                    <v-card-text v-if="datasummary.sharedQuestions.questions.length">
                        <div>
                            <v-flex xs12>
                                <v-layout v-for="(sharedq, i) in datasummary.sharedQuestions.questions" :key="'sharedQuestion-'+i" class="padding-bottom-xs padding-top-xs list summary-question-row">
                                    <v-flex xs4 sm3 md3 lg3 class="break-word">
                                        <p>{{sharedq.questionName}}</p>
                                    </v-flex>
                                    <v-flex xs5 sm6 md6 lg6>
                                        <p>{{sharedq.questionText}}</p>
                                    </v-flex>
                                    <v-flex xs3 sm3 md3 lg3>
                                         <p>{{sharedq.answerText}}
                                             <AnswerInfoPopup
                                             v-if="(getAppPropertyValueArray('SHOW_AVAILABLE_ANSWERS', {mustUppercaseAll: true}).indexOf('SUMMARY') > -1)"
                                             :questionList="sharedq.availableAnswers" />

                                         </p>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="!datasummary.sharedQuestions.questions.length">

                        <p>{{datasummary.texts["api.summary.communication.answer.nothing"]}}</p>

                    </v-card-text>
                </v-card>
            </v-expansion-panel-content>


        </v-expansion-panel>
    </div>

</template>

<script>
import {mapGetters} from 'vuex';
import CollapseIcon from "../../../common/components/svg/shared/CollapseIcon";
import ExpandIcon from "../../../common/components/svg/shared/ExpandIcon";
import SvgButton from "../../../common/components/shared/SvgButton";
import AnswerInfoPopup from "../../../common/components/shared/AnswerInfoPopup";
import WarningIcon from "../../../common/components/svg/shared/warningIcon.vue";

export default {
        name: "SummaryContentPanel",
        components: {WarningIcon, ExpandIcon, CollapseIcon, SvgButton,AnswerInfoPopup},
        props: {
            datasummary: {
                type: Object,
                required: true
            },
            panelDataKey: {
                type: String,
                default: ''
            },
            panelKeySuffix: {
                type: String,
                default: ''
            },
            isExpanded: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            ...mapGetters({
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getIsThemeDarkActive : 'TranslationStore/getIsThemeDarkActive',
                getDecisionItemColor: 'ThemeStore/getDecisionItemColor',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
            }),
            mustShowPanel() {
                return (sectionKey) => {
                    if (!this.panelDataKey || this.panelDataKey === '') {
                        return true;
                    }
                    else {
                        return (this.panelDataKey === sectionKey) ? true : false;
                    }
                }
            }
        },

        mounted() {
            // Because Vuetify doesn't emit any event when an expansion panel is toggled, we attach our own event that
            // will be triggered when the panel is toggled. We need this event in order to synchronize panels between
            // the two columns, when summary translation is active.
            const panelHeader = document.querySelector('#' + this.panelDataKey + this.panelKeySuffix + ' .expansion-panel__header');
            panelHeader.addEventListener('click', this.onClickPanelHeader);
        },

        beforeDestroy() {
            const panelHeader = document.querySelector('#' + this.panelDataKey + this.panelKeySuffix + ' .expansion-panel__header');
            if (panelHeader !== null) {
                panelHeader.removeEventListener('click', this.onClickPanelHeader);
            }
        },


        methods: {

            onClickPanelHeader() {

                const refPanel = this.$refs["panel-content-" + this.panelDataKey + this.panelKeySuffix];

                if (typeof refPanel === 'undefined') {
                    return;
                }

                this.$nextTick(() => {
                    // Without $nextTick, refPanel.isActive would have the previous (old) value, not the new one, that is set
                    // after toggle. So we have to use $nextTick in order to be able to use the value of refPanel.isActive
                    // that is set after the user toggles the panel.
                    // NOTE: "isActive" tells if the expansion panel is expanded or collapsed.
                    //          isActive === TRUE means the panel is expanded.
                    //          isActive === FALSE means the panel is collapsed.

                    this.$emit('onTogglePanel', {
                        sectionKey: this.panelDataKey,
                        isExpanded: refPanel.isActive
                    });
                });
            },


            /**
             * Load and display Summary data for the assessment version given as parameter.
             * @param assessmentToken
             * @param assessmentVersion
             */
            goToSummaryVersionPage(assessmentToken, assessmentVersion) {

                let urlParams = {...this.$route.query};

                urlParams.assessment = assessmentToken;
                urlParams.version = assessmentVersion;

                let emitPayload = {
                    assessmentToken: assessmentToken,
                    assessmentVersion: assessmentVersion,
                };

                if (typeof urlParams.msitat !== "undefined") {
                    emitPayload.msitat = this.$route.query.msitat;
                }

                // Update the url...
                this.$router.push({
                    name: "SummaryPage",
                    query: urlParams
                }, () => { // onComplete
                    // ... then notify the page about the need to refresh the page content (just the content, not the page itself,
                    // not a browser refresh!) by emitting a custom event that will trigger an API request that
                    // brings fresh new content from the server, corresponding to the new assessment version.
                    this.$emit('onChangeSummaryVersion', emitPayload);
                });
            },

        }
    }
</script>

<style lang="scss" scoped>

    .container .layout.page-content.layout-summary-page {
    margin-bottom: 70px;

    }

    .card > .card__text {
    padding-left: 5px;
    border-top: 1px solid #efebeb;
    }

    .row-symptom-headline {

    background-color: $color-element-outline;
    font-weight: $font-weight-default;
    margin-bottom: -11px !important;
    color: $color-body-text;
    }

    .expansion-list {
    padding-bottom: 15px;
    }

    .margin-bottom-section {
    margin-bottom: 10px;
    }

    .margin-bottom-info > div > div {
    margin-bottom: 10px;
    }

    .headline-sections .display-section:first-of-type .row-symptom-headline{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    }


    .headline-sections .display-section:last-of-type .row-symptom-headline {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    }

    .symptom-name {
    margin-bottom: 10px;
    }

    .decisions-container .card>:first-child:not(.btn),
    .decisions-container .card > :last-child:not(.btn){
    border-top: none !important;
    border-bottom: none !important;
    }

    .scrolling-content-summary {
    top: 140px;
    position: fixed;
    margin-left: auto;
    margin-right: auto;
    bottom: 60px;
    overflow: auto;
    width: 100%;
    padding-top: 15px;
    overflow-x: hidden !important;

        li.recommendationlist {
            list-style-type: disc !important;
            margin-left: 15px;
        }
    }

    .clickclass {
    color: red !important;
    }

    .container.grid-list-xl .layout.page-content.layout-summary-page{
    margin-top: 0;
    }

    .section{
    margin-top: 5px;
    }

    .chapters.highlight {
    border-left: 3px solid $color-brand-primary;

        .list__tile__content .list__tile__title {
        color: $color-brand-primary;
        }
    }




    .scrolling-content-summary p,
    .scrolling-content-summary li {
    font-weight: $font-weight-default;
    }

    .symptom-name {
        margin-bottom: 0;
    }


    .fitword {
    word-break: break-all;
    }

    .scrolling-content-summary td {
        vertical-align: top !important;

        &:first-child {
            /*padding-right: 50px;*/
            /*padding-left: 10px;*/

            h4 {
                //min-width: 165px;
            }
        }
    }

    .assessment-content-table{
        width: 100%;

         td {
             vertical-align: top !important;
           //  padding: 10px;
         }
    }

    .assessment-generalquestions-table {
        width: 100%;
        padding-top:12px;
        padding-bottom: 12px;
        border-collapse:separate;
        border-spacing: 0 5px;

        .q-name {
            width: 18%;
        }

        .q-text {
            width: 65%;
            padding-right: 30px;
        }

        .a-text {
            width: 17%;
        }

        tr {
            background-color: $color-elevation-background !important;
            margin-bottom: 5px;
            color: $color-headings-text;
            border-radius: 5px;

            td {
                padding-top: 12px;
            }
        }

        tr td:first-child {
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
        }
        tr td:last-child { border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;; }
    }

    .di-headline {
        padding-right: 10px;
    }

    .assessment-content-table tr td:nth-child(2) {
        padding-left: 5px;
    }

    .assessment-content-table {

        td.icon-warning {
          //  width: 28px;
        }
    }

    .note-table {
        margin-bottom: 10px !important;

        p {
            margin-bottom: 0 !important;
        }
    }

    .summary-table-td td {
        padding-top: 5px !important;
        padding-bottom: 10px !important;
    }

    .code-system li {
        font-weight: $font-weight-regular;
        list-style-type: disc !important;
        margin-left: 15px;
    }

    .popup-scoring.summary-popup{
        .code-system-value li {
            list-style-type: disc !important;
        }
    }

    ul.warning-list {
        li {
            list-style-type: disc !important;
            margin-left: 18px !important;
        }
    }

    .version-nav-link {
        color: $color-brand-primary;
        text-decoration: underline;
    }

</style>




// WEBPACK FOOTER //
// src/professional/components/summary/SummaryContentPanel.vue